export default {
  questionHover: 'question_hover',
  questionClick: 'question_click',
  chartUpdated: 'chart_updated'
}
